import { GPTGameNameType } from 'src/EXPERIMENTAL_LIB/gpt/games';

export const GPT_BANNER_CONFIG: Partial<Record<GPTGameNameType, BannerProps>> = {
  cardGame: {
    background: 'linear-gradient(149deg, #F34D00 8.2%, #D357FE 57.8%, #FDC700 101.15%)',
    boxShadow: ' -1px 4px 9px 0px #A0089D',
    textShadow: '0px 2px 4px rgba(212, 0, 4, 0.93)'
  },
  birdGame: {
    background: 'linear-gradient(149deg, #F34D00 8.2%, #D357FE 57.8%, #FDC700 101.15%)',
    boxShadow: ' -1px 4px 9px 0px #A0089D',
    textShadow: '0px 2px 4px rgba(212, 0, 4, 0.93)'
  },
  wheelOfFortune: {
    background: 'linear-gradient(146deg, #9B55FD 14.02%, #1D4ED8 57.77%, #60A5FA 86.59%)',
    boxShadow: '-1px 4px 9px 0px #7A73E5',
    textShadow: '0px 2px 4px rgba(0, 23, 81, 0.93)'
  }
  // dailyBonus: {
  //   background: 'var(--gpt_card_400)',
  //   boxShadow: '-1px 4px 9px 0px var(--global-fuchsia-800, #A0089D)',
  //   textShadow: '0px 2px 4px rgba(212, 0, 4, 0.93)'
  // }
};

export type BannerProps = {
  background: string;
  boxShadow: string;
  textShadow: string;
};
